import { render } from "./App.vue?vue&type=template&id=fec01e20"
const script = {}

import "./App.vue?vue&type=style&index=0&id=fec01e20&lang=scss"
script.render = render

export default script